import React, { useState } from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';
import { useApp } from '../context/AppContext';

export const FAQsPage = () => {
  const { t } = useApp();
  const [openIndex, setOpenIndex] = useState(0);

  const faqItems = t('faqs.items') || [];

  return (
    <div className="min-h-screen pt-24 pb-16" data-testid="faqs-page">
      {/* Hero */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#00D4FF]/10 text-[#00D4FF] text-sm font-medium mb-6">
            <HelpCircle className="w-4 h-4" />
            Support
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-testid="faqs-title">
            {t('faqs.title')}
          </h1>
          <p className="text-xl text-white/60 max-w-2xl mx-auto">
            Find answers to common questions about our products and services
          </p>
        </div>
      </section>

      {/* FAQs */}
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6">
          <div className="space-y-4">
            {Array.isArray(faqItems) && faqItems.map((item, idx) => (
              <div
                key={idx}
                className="card-dark overflow-hidden"
                data-testid={`faq-item-${idx}`}
              >
                <button
                  onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-white/5 transition-colors"
                >
                  <span className="font-medium pr-4">{item.q}</span>
                  <ChevronDown 
                    className={`w-5 h-5 text-[#00D4FF] flex-shrink-0 transition-transform ${
                      openIndex === idx ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {openIndex === idx && (
                  <div className="px-6 pb-5 text-white/70 leading-relaxed whitespace-pre-line">
                    {item.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Still Have Questions */}
      <section className="py-16 bg-[#0A0A0A]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold mb-4">{t('faqs.stillHaveQuestions')}</h2>
          <p className="text-white/60 mb-8">
            {t('faqs.cantFind')}
          </p>
          <a href="/contact" className="btn-primary">
            {t('faqs.contactSupport')}
          </a>
        </div>
      </section>
    </div>
  );
};
